import i18n from "i18next";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

const resources = {
  // en: {
  //   translation: translationEN,
  // },
};

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    resources,
    returnObjects: true,
    fallbackLng: "en",
    debug: true,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
